import {AccountPerformanceViewStoreFactory} from "./AccountPerformanceViewStoreFactory";
import {AccountPerformanceService} from "./AccountPerformanceService";

export default angular.module("tfApp.performance.service", [])
                      .service(AccountPerformanceViewStoreFactory.id, AccountPerformanceViewStoreFactory)
                      .service(AccountPerformanceService.id, AccountPerformanceService)
    .name;
